import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import MarketingSidebar from '../components/Marketing/ui/Sidebar';
import MarketingHeader from '../components/Marketing/ui/Header';
import { getMarketingPageTitle } from '../utils/marketingPageTitle';

const MarketingLayout: React.FC = () => {
  const location = useLocation();

  return (
    <div className="flex h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-200">
      <MarketingSidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <MarketingHeader title={getMarketingPageTitle(location.pathname)} />
        <main className="flex-1 overflow-y-auto p-6 dark:text-gray-100">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default MarketingLayout;
